// OperatorMultiTVComponent.jsx
import React from "react";
import { OperatorProvider } from "../../utils/OperatorContext";
import OperatorComponent from "./OperatorComponent";

const TVs = [
  { id: 1, label: "تلویزیون ۱" },
  { id: 2, label: "تلویزیون ۲" },
  { id: 3, label: "تلویزیون ۳" },
  { id: 4, label: "تلویزیون ۴" },
];

export default function OperatorMultiTVComponent({ socketData }) {
  return (
    <div className="min-h-screen bg-slate-950 p-6 space-y-6">
      <h1 className="text-2xl font-bold text-slate-100">کنترل چند تلویزیون</h1>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {TVs.map((tv) => (
          <div
            key={tv.id}
            className="rounded-2xl border border-slate-800 bg-slate-900/60 p-3 shadow-lg"
          >
            <h2 className="text-slate-200 text-lg font-semibold mb-3">
              {tv.label}
            </h2>
            <OperatorProvider tvId={tv.id}>
              <OperatorComponent socketData={socketData} />
            </OperatorProvider>
          </div>
        ))}
      </div>
    </div>
  );
}
